export function isE2EBypassEnabled(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const params = new URLSearchParams(window.location.search);
    const value = (params.get("e2e") || "").toLowerCase();
    return value === "1" || value === "true";
  } catch {
    return false;
  }
}

export function getMockAddressDetails(overrides: Record<string, any> = {}) {
  return {
    streetNumber: "123",
    streetName: "Main St",
    municipality: "Toronto",
    province: "ON",
    postalCode: "M5B 2B8",
    country: "Canada",
    isDetailAddress: true,
    ...overrides,
  };
}

export function getMockAddressSearchResponse(inputAddress?: string) {
  const normalized = (inputAddress || "Toronto").trim();
  const details = getMockAddressDetails({ postalCode: /[a-z]\d[a-z]/i.test(normalized) ? normalized : "M5B 2B8" });

  return {
    status: "OK",
    mailAddressChoice: {
      addressDetails: details,
      addressAlternatives: [
        `${details.streetNumber} ${details.streetName}, ${details.municipality}, ${details.province}, ${details.postalCode}`,
        `120 Main St, ${details.municipality}, ${details.province}, ${details.postalCode}`,
      ],
    },
  };
}

export function getMockPostalLookupResponse(postalCode?: string) {
  const details = getMockAddressDetails({ postalCode: postalCode || "M5B 2B8", isNoStreetNoAddress: true });
  return {
    status: "OK",
    mailAddressChoice: [details],
  };
}

export function getMockButtonApiResponse(preferredStatusCode?: string | number) {
  const statusCode = preferredStatusCode ?? 200;
  return {
    status: 200,
    data: {
      status: "OK",
      statusCode,
      data: { statusCode },
      WebResponse: { statusCode, data: {} },
      messageEn: "",
      messageFr: "",
    },
  };
}
